import { ref, onMounted, getCurrentInstance } from 'vue';
import { getListApprovalDeputyCOO, approveIDPByDeputyCOO, rejectIDPByDeputyCOO } from './api';

export function useApprovalDeputyCOO() {
  const instance = getCurrentInstance();
  const swal = instance?.proxy?.$swal;
  const trainings = ref([]);
  const employees = ref([]);
  const pagination = ref({
    totalItems: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  });
  const loading = ref(false);
  const error = ref(null);

  // Get token from URL query parameter (Vue 2 compatible)
  const token = instance?.proxy.$route?.query?.token;

  // // Fetch training fields (columns)
  // async function fetchTrainingFields() {
  //   if (!token) {
  //     error.value = 'Token tidak ditemukan di URL';
  //     return;
  //   }

  //   try {
  //     loading.value = true;
  //     const response = await getListApprovalDeputyCOO({ token });

  //     if (response.httpCode === 200 && response.data) {
  //       trainings.value = response.data.map(item => ({
  //         id: item.id,
  //         title: item.title
  //       }));
  //     }
  //   } catch (err) {
  //     error.value = 'Gagal memuat data training';
  //     console.error(err);
  //   } finally {
  //     loading.value = false;
  //   }
  // }

  // Fetch employee approval data
  async function fetchEmployeeData(params = {}) {
    if (!token) {
      error.value = 'Token tidak ditemukan di URL';
      return;
    }

    try {
      loading.value = true;
      const page = params.page || pagination.value.page || 1;
      const limit = params.limit || pagination.value.limit || 10;
      const response = await getListApprovalDeputyCOO({ token, page, limit });

      if (response.httpCode === 200 && response.data) {
        employees.value = response.data.data || [];
        pagination.value = {
          totalItems: response.data.totalItems || 0,
          page: response.data.page || page,
          limit: response.data.limit || limit,
          totalPages: response.data.totalPages || 1,
        };
      }
    } catch (err) {
      error.value = 'Gagal memuat data karyawan';
      console.error(err);
    } finally {
      loading.value = false;
    }
  }

  async function fetchAllEmployeeData() {
    if (!token) {
      error.value = 'Token tidak ditemukan di URL';
      return [];
    }

    const totalItems = pagination.value.totalItems || pagination.value.limit || 1000;
    const response = await getListApprovalDeputyCOO({
      token,
      page: 1,
      limit: totalItems,
    });

    if (response?.httpCode === 200 && response.data) {
      return response.data.data || [];
    }

    return [];
  }

  // Update status per employee per training
  function updateStatus(empId, trainingId, newStatus) {
    const emp = employees.value.find(e => e.id === empId);
    if (emp) {
      if (!emp.status) emp.status = {};
      emp.status[trainingId] = newStatus;
    }
  }

  // Handle approve selected IDP submissions
  async function handleApproveAPI(ids = []) {
    try {
      loading.value = true;
      const response = await approveIDPByDeputyCOO({ token, ids });

      if (response && response.httpCode === 200) {
        // Refresh data
        await fetchEmployeeData({
          page: pagination.value.page,
          limit: pagination.value.limit,
        });
        swal?.('Success', 'Pengajuan IDP berhasil disetujui.', 'success');
        return true;
      } else {
        swal?.('Error', 'Pengajuan IDP belum berhasil disetujui', 'error');
        return false;
      }
    } catch (err) {
      console.error('Error approving IDP:', err);
      swal?.('Error', 'Terjadi kesalahan saat menyetujui pengajuan IDP', 'error');
      return false;
    } finally {
      loading.value = false;
    }
  }

  // Handle reject selected IDP submissions with reason
  async function handleRejectAPI(reason, ids = []) {
    try {
      loading.value = true;
      const response = await rejectIDPByDeputyCOO({
        token,
        reason,
        ids,
      });

      if (response && response.httpCode === 200) {
        // Refresh data
        await fetchEmployeeData({
          page: pagination.value.page,
          limit: pagination.value.limit,
        });
        swal?.('Success', 'Pengajuan IDP berhasil ditolak.', 'success');
        return true;
      } else {
        swal?.('Error', 'Pengajuan IDP belum berhasil ditolak', 'error');
        return false;
      }
    } catch (err) {
      console.error('Error rejecting IDP:', err);
      swal?.('Error', 'Terjadi kesalahan saat menolak pengajuan IDP', 'error');
      return false;
    } finally {
      loading.value = false;
    }
  }

  // Initialize data on mount
  onMounted(async () => {
    // await fetchTrainingFields();
    await fetchEmployeeData();
  });

  return {
    employees,
    trainings,
    pagination,
    loading,
    error,
    updateStatus,
    token,
    fetchEmployeeData,
    fetchAllEmployeeData,
    handleApproveAPI,
    handleRejectAPI,
  };
}
